import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { listApplications } from "../../slices/veloxity/pushNotification/listApplication";
import { sendMessage } from "../../slices/veloxity/pushNotification/sendMessage";
import { showErrorAlert, showSuccessAlert } from "../custom/sweetalertHelper";

const TestPushNotificationModal = ({ isOpen, toggleModalTestPN }) => {
  const dispatch = useDispatch();

  const { loading: listLoading, applications } = useSelector(
    (state) => state.listApplications
  );

  const { loading: sendLoading } = useSelector((state) => state.sendMessage);

  const [selectedApplicationId, setSelectedApplicationId] = useState("");
  const [formData, setFormData] = useState({
    deviceId: "",
    title: "",
    body: "",
    imageUrl: "",
    data: "",
  });

  // Fetch applications when the modal opens
  useEffect(() => {
    if (isOpen) {
      dispatch(listApplications());
    }
  }, [isOpen, dispatch]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleSendMessage = () => {
    const requestData = {
      ...formData,
      data: formData.data ? JSON.parse(formData.data) : {},
    };

    dispatch(sendMessage({ applicationId: selectedApplicationId, requestData }))
      .unwrap()
      .then(() => {
        showSuccessAlert("Success", "Message sent successfully!");
        toggleModalTestPN();
      })
      .catch((err) => {
        console.error("Error sending message:", err);
        showErrorAlert(
          "Error",
          "Failed to send the message. Please try again."
        );
      });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleModalTestPN}>
      <ModalHeader toggle={toggleModalTestPN}>
        Test Push Notification
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="applicationId">Select Application</Label>
          <Input
            type="select"
            id="applicationId"
            value={selectedApplicationId}
            onChange={(e) => setSelectedApplicationId(e.target.value)}
            disabled={listLoading}
          >
            <option value="" disabled>
              {listLoading ? "Loading applications..." : "Select an application"}
            </option>
            {applications &&
              applications.map((app) => (
                <option key={app.id} value={app.id}>
                  {app.name}
                </option>
              ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="deviceId">Device ID</Label>
          <Input
            type="text"
            id="deviceId"
            name="deviceId"
            value={formData.deviceId}
            onChange={handleInputChange}
            placeholder="Enter Device ID"
          />
        </FormGroup>
        <FormGroup>
          <Label for="title">Title</Label>
          <Input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            placeholder="Enter Title"
          />
        </FormGroup>
        <FormGroup>
          <Label for="body">Body</Label>
          <Input
            type="text"
            id="body"
            name="body"
            value={formData.body}
            onChange={handleInputChange}
            placeholder="Enter Body"
          />
        </FormGroup>
        <FormGroup>
          <Label for="imageUrl">Image URL</Label>
          <Input
            type="text"
            id="imageUrl"
            name="imageUrl"
            value={formData.imageUrl}
            onChange={handleInputChange}
            placeholder="Enter Image URL"
          />
        </FormGroup>
        <FormGroup>
          <Label for="data">Custom Data (JSON)</Label>
          <Input
            type="textarea"
            id="data"
            name="data"
            value={formData.data}
            onChange={handleInputChange}
            placeholder='{"key1": "value1", "key2": "value2"}'
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSendMessage}
          disabled={sendLoading || !selectedApplicationId}
        >
          {sendLoading ? "Sending..." : "Send"}
        </Button>
        <Button color="secondary" onClick={toggleModalTestPN}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TestPushNotificationModal;
